const styles = theme => ({
  appBar: {
    backgroundColor: theme.palette.white,
  },
  toolbar: {
    width: '100%',
    maxWidth: theme.breakpoints.values.md,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1, 3),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(1, 4),
    },
  },
  seller: {
    width: '100%',
    maxHeight: '2.8rem',
    lineHeight: '1.4rem',
    overflow: 'hidden',
    textTransform: 'uppercase',
    color: theme.typography.body2.color,
    fontSize: '1rem',
    flex: 1,
  },
  safeEnvironment: {
    flex: 1,
    justifyContent: 'flex-end',
    padding: theme.spacing(1, 0),
  },
})

export default styles
